import React, { useState, useEffect } from 'react';
import { useAuth } from "../contexts/Auth";
import { withRouter } from 'react-router-dom';
import firebase from '../config/firebase';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useRef } from 'react';


const Container = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: auto;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
`;

const PageTitle = styled.h1`
    text-align: center;
    font-size: 24px;
    margin-bottom: 20px;
`;

const StatsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    background: #fff;
    padding: 10px;
    border-radius: 5px;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;
`;

const QuestionText = styled.p`
    font-size: 16px;
    font-weight: bold;
`;

const Metadata = styled.div`
    padding: 8px;
    font-size: 14px;
    color: #666;
`;


const InputArea = styled.textarea`
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    resize: none;
`;

const AnswerContainer = styled.div`
    margin-top: 10px;
    background: #e9ecef;
    padding: 10px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

const StyledButton = styled.button`
    background: ${(props) => props.bg || '#007bff'};
    color: white;
    border: none;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    width: 48%;
    text-align: center;
    margin-top: 5px;

    &:hover {
        background: ${(props) => props.hover || '#0056b3'};
    }
`;

const FullWidthButton = styled(StyledButton)`
    width: 100%;
`;

const FilterContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
`;

const QuestionContainer = styled.div`
    background: white;
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 8px;
    border: 2px solid #dc3545; /* Crveni border */
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    gap: 10px;
`;
const QuestionBox = styled.div`
    background: #f1f1f1; /* Siva podloga za pitanje */
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
`;

const AnswerBox = styled.div`
    background: #dbeafe; /* Svijetlo plava podloga za odgovor */
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
`;


const AppQuestions = ({ history }) => {
    const [rows, setRows] = useState([]);
    const [allRows, setAllRows] = useState([]);
    const [answer, setAnswer] = useState({ id: '', text: '' });
    const [tempAnswer, setTempAnswer] = useState('');
    const [editing, setEditing] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [showUnanswered, setShowUnanswered] = useState(true);
    const auth = useAuth();
    const [visibleCount, setVisibleCount] = useState(20);
    const [showAll, setShowAll] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredResults, setFilteredResults] = useState([]);
    const [selectedQuestion, setSelectedQuestion] = useState(null);


    useEffect(() => {
        const questionsRef = firebase.database().ref('app_questions');

        const fetchData = questionsRef.on('value', (snapshot) => {
            if (snapshot.val()) {
                const data = Object.values(snapshot.val()).reverse();
                setAllRows(data);
                setRows(data.filter(r => !r.answer).slice(0, 20)); // Prikazuje samo prvih 20 neodgovorenih pitanja
            }
        });

        return () => questionsRef.off('value');
    }, []);

    const loadMoreQuestions = () => {
        if (rows.length < allRows.length) {
            setRows(prevRows => [...prevRows, ...allRows.slice(prevRows.length, prevRows.length + 20)]);
        }
    };
    

    const filterByDate = (date) => {
        setSelectedDate(date);
        const filtered = allRows.filter(row => {
            if (!row.timeCreated) return false;
            const rowDate = new Date(row.timeCreated);
            return !isNaN(rowDate) && rowDate.toDateString() === date.toDateString();
        });
        setRows(filtered);
    };
    const handleSearch = (query) => {
        setSearchQuery(query);
    
        if (!query.trim()) {
            setFilteredResults([]);
            setSelectedQuestion(null);
            return;
        }
    
        const results = allRows.filter(row => 
            row.question.toLowerCase().includes(query.toLowerCase()) || 
            (row.answer && row.answer.toLowerCase().includes(query.toLowerCase()))
        );
    
        setFilteredResults(results);
    };
    

    const handleAnswer = async (id) => {
        const currentAnswer = tempAnswer.trim() || answer.text.trim(); // Uzimamo vrijednost iz answer.text ako tempAnswer nije postavljen
        
        if (!currentAnswer) {
            alert("Odgovor ne može biti prazan!");
            return;
        }
    
        try {
            var questionsRef = firebase.database().ref('app_questions');
            await questionsRef.child(id).update({
                answer: currentAnswer, // Ovdje koristimo validan odgovor
                timeAnswered: new Date().toLocaleString(),
                answeredBy: auth.user.email
            });
    
            // Ažuriramo prikaz
            setRows(prevRows => prevRows.filter(q => q.id !== id)); // Skida ga iz prikaza neodgovorenih
            setAllRows(prevRows => prevRows.map(q => 
                q.id === id ? { ...q, answer: currentAnswer, timeAnswered: new Date().toLocaleString(), answeredBy: auth.user.email } : q
            )); // Dodaje ga u bazu
            setEditing(null);
            setTempAnswer(""); // Resetiraj input polje
        } catch (error) {
            console.log("Greška pri ažuriranju odgovora:", error);
        }
    };
    
    const notificationSound = useRef(new Audio(process.env.PUBLIC_URL + "/sound/notification.mp3"));
    const lastSeenQuestionId = useRef(null);  // Čuva ID zadnjeg viđenog pitanja    
    useEffect(() => {
        const questionsRef = firebase.database().ref('app_questions');
    
        const fetchData = questionsRef.on('value', (snapshot) => {
            if (snapshot.val()) {
                const data = Object.values(snapshot.val()).reverse();
    
                // ⚠️ Provjera da li je `notificationSound.current` inicijalizovan prije nego što ga koristimo
                if (notificationSound.current) {
                    // Ako je stiglo novo pitanje i nije isto kao zadnje viđeno
                    if (data.length > 0 && lastSeenQuestionId.current !== data[0]?.id) {
                        if (lastSeenQuestionId.current !== null) { 
                            notificationSound.current.play().catch(err => console.error("Greška pri puštanju zvuka:", err));
                        }
                        lastSeenQuestionId.current = data[0]?.id;
                    }
                }
    
                // Ažuriraj sva pitanja
                setAllRows(data);
    
                // Ako gledamo neodgovorena pitanja, automatski ih ažuriraj
                if (showUnanswered && !showAll) {
                    setRows(data.filter(r => !r.answer).slice(0, 20));
                }
            }
        });
    
        return () => questionsRef.off('value');
    }, [showAll, showUnanswered]);
    
 
    const clearFilters = () => {
        setSearchQuery("");
        setSelectedDate(null);
        setFilteredResults([]);
        setSelectedQuestion(null);
        setShowAll(false);
        setRows(allRows.filter(r => !r.answer).slice(0, 20)); // Vrati na neodgovorena pitanja
    };
    
    const [selectedQuestionId, setSelectedQuestionId] = useState(null); // Prati koje pitanje je kliknuto

const handleQuestionClick = (questionId) => {
    setSelectedQuestionId(prevId => prevId === questionId ? null : questionId); // Ako kliknemo isto pitanje, sakrij ga
};

const handleDeleteQuestion = async (id) => {
    if (!window.confirm("Da li ste sigurni da želite obrisati ovo pitanje?")) {
        return;
    }

    try {
        const questionsRef = firebase.database().ref('app_questions');
        await questionsRef.child(id).remove();

        // Ažuriraj prikaz tako da ukloni obrisano pitanje
        setRows(prevRows => prevRows.filter(q => q.id !== id));
        setAllRows(prevRows => prevRows.filter(q => q.id !== id));
    } catch (error) {
        console.error("Greška pri brisanju pitanja:", error);
        alert("Došlo je do greške pri brisanju pitanja.");
    }
};


    return (
        <Container>
            <PageTitle>App Pitanja</PageTitle>
            <StatsContainer>
                <p><strong>Ukupan broj pitanja:</strong> {allRows.length}</p>
                <p><strong>Pitanja bez odgovora:</strong> {allRows.filter(r => !r.answer).length}</p>
            </StatsContainer>

            <ButtonContainer>
                <StyledButton bg="#28a745" hover="#218838" onClick={() => {
                    setShowUnanswered(true);
                    setRows(allRows.filter(r => !r.answer));
                }}>Prikaži neodgovorena</StyledButton>

<StyledButton 
    bg="#007bff" 
    hover="#0056b3" 
    onClick={() => {
        setShowAll(true);  // Prvo postavi showAll na true
        setTimeout(() => {  // Kratka pauza da osigura re-render prije ažuriranja state-a
            setRows(allRows.slice(0, visibleCount));
        }, 10);
    }}
>
    Prikaži sva pitanja
</StyledButton>
            </ButtonContainer>

            {showAll && (
                <FilterContainer>
                    <DatePicker
                        selected={selectedDate}
                        onChange={filterByDate}
                        placeholderText="Odaberi datum"
                    />
                </FilterContainer>
            )}
            {showAll && (
    
    <FilterContainer>
        <input
            type="text"
            placeholder="Pretraži pitanja i odgovore..."
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
            style={{
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                width: "60%",
                marginRight: "10px"
            }}
        />

       <StyledButton bg="#dc3545" hover="#c82333" onClick={clearFilters}>
        Resetuj filtere
    </StyledButton>
    
    </FilterContainer>
)}
{filteredResults.length > 0 && (
            <div style={{ background: "#fff", padding: "10px", borderRadius: "8px", boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)" }}>
                <p><strong>Rezultati pretrage:</strong></p>
                <ul style={{ listStyle: "none", padding: 0 }}>
                    {filteredResults.map((row) => (
                        <li key={row.id} 
                        onClick={() => handleQuestionClick(row.id)} 
                        style={{ cursor: "pointer", padding: "5px 0", borderBottom: "1px solid #ddd" }}>
                        
                        <strong>{row.question}</strong>
                    
                        {selectedQuestionId === row.id && (
                            <div style={{
                                marginTop: "5px", 
                                padding: "10px", 
                                borderRadius: "5px",
                                background: row.answer ? "#dbeafe" : "#f8d7da",
                                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)"
                            }}
                            onClick={(e) => e.stopPropagation()}  // SPRJEČAVA ZATVARANJE NA KLIK
                            >
                                {row.answer ? (
                                    <p>{row.answer}</p>
                                ) : (
                                    <p style={{ color: "red", fontWeight: "bold" }}>Nema odgovora za ovo pitanje.</p>
                                )}
                            </div>
                        )}
                    </li>                    
                    ))}
                </ul>
            </div>
        )}
  
{/* {selectedQuestion && (
    <QuestionContainer>
        <Metadata>
            <p><strong>Email:</strong> {selectedQuestion.email}</p>
            <p><strong>Datum kreiranja:</strong> {selectedQuestion.timeCreated}</p>
        </Metadata>

        <QuestionBox>
            <QuestionText>{selectedQuestion.question}</QuestionText>
        </QuestionBox>

        {selectedQuestion.answer ? (
            <AnswerBox>
                <p>{selectedQuestion.answer}</p>
                <Metadata>
                    <p><strong>Odgovorio:</strong> {selectedQuestion.answeredBy}</p>
                    <p><strong>Datum odgovora:</strong> {selectedQuestion.timeAnswered}</p>
                </Metadata>
            </AnswerBox>
        ) : (
            <p style={{ color: "red", fontWeight: "bold" }}>Nema odgovora za ovo pitanje.</p>
        )}

        <StyledButton bg="#dc3545" hover="#c82333" onClick={() => setSelectedQuestion(null)}>
            Zatvori pregled
        </StyledButton>
    </QuestionContainer>
)} */}


{rows.map(row => (
    <QuestionContainer key={row.id}>
        <Metadata>
            <p><strong>Email:</strong> {row.email}</p>
            <p><strong>Datum kreiranja:</strong> {row.timeCreated}</p>
        </Metadata>

        <QuestionBox>
            <QuestionText>{row.question}</QuestionText>
        </QuestionBox>

        {row.answer ? (
            <AnswerBox>
                {editing === row.id ? (
                    <>
                        <InputArea
                            value={tempAnswer}
                            onChange={e => setTempAnswer(e.target.value)}
                        />
                        <FullWidthButton bg="#28a745" hover="#218838" onClick={() => handleAnswer(row.id)}>Sačuvaj</FullWidthButton>
                    </>
                ) : (
                    <>
                        <p>{row.answer}</p>
                        <Metadata>
                            <p><strong>Odgovorio:</strong> {row.answeredBy}</p>
                            <p><strong>Datum odgovora:</strong> {row.timeAnswered}</p>
                        </Metadata>
                        <FullWidthButton bg="#ffc107" hover="#e0a800" onClick={() => { setEditing(row.id); setTempAnswer(row.answer); }}>Uredi</FullWidthButton>
                    </>
                )}
            </AnswerBox>
        ) : (
            <>
                <InputArea
                    value={answer.id === row.id ? answer.text : ''}
                    onChange={e => setAnswer({ id: row.id, text: e.target.value })}
                />
                <FullWidthButton bg="#007bff" hover="#0056b3" onClick={() => handleAnswer(row.id)}>Odgovori</FullWidthButton>
                <FullWidthButton bg="#dc3545" hover="#c82333" onClick={() => handleDeleteQuestion(row.id)}>Obriši</FullWidthButton>
            </>
        )}
    </QuestionContainer>
))}

            {showAll && rows.length < allRows.length && (
                <StyledButton bg="#28a745" hover="#218838" onClick={loadMoreQuestions} style={{ width: '100%', marginTop: '20px' }}>
                    Prikaži više
                </StyledButton>
            )}
        </Container>
    );
};

export default withRouter(AppQuestions);
